import { SynApi } from '@lumapps/login/api';

/**
 * send email for magic link login
 * @return {Promise} The request promise.
 */

export const SendEmailForm = (organizationId: string, email: string, nextUrl?: string) =>
    SynApi.post(`v1/organizations/${organizationId}/authenticated-magic-links`, { userEmail: email, nextUrl });
